import { gql } from "@apollo/client";

export const MUTATION_CREATE_USER_OFFER = gql`
  mutation CreateUserOffer($userId: ID!, $offerId: ID!) {
    createUserOffer(userId: $userId, offerId: $offerId) {
      id
    }
  }
`;
